import { DefaultEmptyStateComponent } from '@app/infrastructure/state-switcher/components/default-empty-state/default-empty-state.component';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [DefaultEmptyStateComponent],
	exports: [DefaultEmptyStateComponent],
})
export class DefaultEmptyStateModule {}
